<template>
  <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
      title="创建要货计划"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="initPurchaseLoading"
        :model="form"
        label-width="50px"
        :rules="ruleValidate">
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题">
            <el-input v-model="form.billTitle"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="form.note" type="textarea" rows="1"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-table :data="form.details" border>
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
                :data="props.row.details"
                default-expand-all
                style="width: 100%;margin-top: 3px">
              <el-table-column
                  prop="materialNo"
                  align="center"
                  label="物料编号"
                  show-overflow-tooltip
                  width="120"/>
              <el-table-column
                  prop="purchaseOrderNo"
                  align="center"
                  label="采购订单号"/>
              <el-table-column
                  prop="poDetailRowNo"
                  align="center"
                  label="采购订单行号"/>
              <el-table-column
                  prop="quantity"
                  align="center"
                  label="要货数量"
                  width="150">
                <template slot-scope="scope">
                  <el-input-number
                      v-model="scope.row.quantity"
                      style="width: 100%"
                      :min="0"
                      @change="changeQuantity(scope.row)"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="roundedValue"
                  align="left"
                  label="舍入值"/>
              <el-table-column
                  prop="supplierName"
                  align="left"
                  label="供应商"/>
              <el-table-column
                  prop="supplierCode"
                  align="left"
                  label="供应商编号"/>
              <el-table-column
                  label="操作"
                  fixed="right"
                  align="center"
                  class-name="vm-table_operate"
                  width="120">
                <template v-slot="scope">
                  <el-button type="danger" @click="deleteDetailRow(props.row,scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
            prop="materialNo"
            align="center"
            label="物料编号"
            show-overflow-tooltip
            width="120"/>
        <el-table-column
            prop="materialName"
            align="left"
            label="物料描述"
            show-overflow-tooltip/>
        <el-table-column
            prop="nextGap"
            align="left"
            width="120"
            label="下周缺口数量"/>
        <el-table-column
            label="操作"
            fixed="right"
            align="center"
            class-name="vm-table_operate"
            width="120">
          <template v-slot="scope">
            <el-button type="primary" @click="addDetails(scope.row,scope.$index)">新增</el-button>
            <el-button type="danger" @click="deleteRow(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
    </span>
    <purchase-plan-select ref="purchasePlanSelect" @select="selectPurchasePlan"/>
  </el-dialog>
</template>

<script>

  import PurchasePlanSelect from "@/views/PurchaseOrderManager/PurchasePlan/PurchasePlanSelect";

  export default {
    components: {PurchasePlanSelect},
    data() {
      return {
        dialogVisible: false,
        innerVisible: false,
        initPurchaseLoading: false,
        form: {
          details: [],
        },
        submitLoading: false,
        ruleValidate: {},
      };
    },
    methods: {
      open(selection) {
        this.dialogVisible = true;
        selection.forEach(orderDetail => {
          let detail = {};
          detail.materialNo = orderDetail.materialNo;
          detail.materialName = orderDetail.materialName;
          detail.nextGap = orderDetail.nextGap;
          detail.requireDeliveryDate = orderDetail.thisWeekDeliveryDate;
          detail.requireId = orderDetail.pkId;
          detail.urgent = orderDetail.urgent;
          this.form.details.push(detail);
        });
        this.initPurchaseOrders();
      },

      checkQuantity(row) {
        const reg = /^[0-9]*[1-9][0-9]*$/;
        if (!reg.test(row.quantity)) {
          this.$confirm("请输入大于0的整数", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
        if (row.quantity > row.qty - row.planQty) {
          this.$confirm("要货数量超过剩余数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
      },
      addDetails(row, index) {
        row.initDetails.forEach(detail => {
          detail.isDisabled = false;
        });
        this.$refs.purchasePlanSelect.open(row, index);
      },
      selectPurchasePlan(row, index) {
        this.form.details[index].details.push(row);

      },
      // 删除行项
      deleteRow(index) {
        this.form.details.splice(index, 1);
      },
      deleteDetailRow(row, index) {
        row.details.splice(index, 1);
      },

      oneDelete(index) {
        this.form.details.splice(index, 1);
      },
      changeQuantity(row) {
        if (row.quantity % row.roundedValue !== 0) {
          this.$message.error("请输入舍入值整数倍的数量!");
        }
      },
      saveHandle() {
        this.form.details.forEach(row => {
          row.billTitle = this.form.billTitle;
          row.note = this.form.note;
        });
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "purchasePlans/insertPurchasePlans", this.form.details)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      initPurchaseOrders() {
        this.initPurchaseLoading = true;
        this.$http
          .post("basic", "purchasePlans/initPurchasePlan", this.form.details)
          .then((res) => {
            if (res.success) {
              this.form.details = res.data;
            }
            this.initPurchaseLoading = false;
          }).catch(() => {
            this.initPurchaseLoading = false;
          });
      },
    },
  };
</script>

<style>
</style>
